// extracted by mini-css-extract-plugin
export default {"loader":"LoadingScreen_loader__b35qw","l10":"LoadingScreen_l10__Xsxo-"};